import {computed, toValue, type MaybeRefOrGetter, type Ref} from 'vue';
import type {PinnedContentHeroSlice} from '@prismicio-types';
import {usePrismicTypeGuards} from '#imports';
import {type DatedContent} from '../resolvePinnedHeroContent';
import type {FilledContent} from '~~/app/composables/contentHelpers';

export function usePinnedContentHeroDisplay(heroContent: Ref<FilledContent | null>, sliceInput: MaybeRefOrGetter<PinnedContentHeroSlice>) {
    const {hasProperty} = usePrismicTypeGuards();

    const heroThumbnail = computed(() => {
        const content = heroContent.value;
        if (!content || content.type === 'collection') return undefined;
        return content.data?.thumbnail;
    });

    const cropsThumbnail = computed(() => heroContent.value?.type === 'article' || heroContent.value?.type === 'pressRelease');

    const showsHeroTime = computed(() => {
        const content = heroContent.value;
        const slice = toValue(sliceInput);
        return !!content && slice.variation === 'default' && content.type !== 'guide' && content.type !== 'collection';
    });

    const heroReleaseDate = computed(() => {
        const data = heroContent.value?.data;
        if (!data || !hasProperty(data, 'releaseDate') || !data.releaseDate) return undefined;
        return data.releaseDate;
    });

    const heroDuration = computed(() => {
        const data = heroContent.value?.data;
        if (!data || !hasProperty(data, 'duration') || data.duration === '') return undefined;
        return data.duration;
    });

    function showsSideDate(item: DatedContent) {
        return item.type !== 'guide' && item.type !== 'collection' && !!item.date;
    }

    return {cropsThumbnail, heroDuration, heroReleaseDate, heroThumbnail, showsHeroTime, showsSideDate};
}
